import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Scrollbars from "react-custom-scrollbars";
import Button from '../../../atoms/button';
import ConfigurationHeader from '../../../components/configuration_header';
import SaveConfiguration from '../../../components/save_configuration';
import SavedConfigurationSection from '../../../components/saved_configuration_section';
import DocumentationSection from '../../../components/documentation_section';
import { saveConfiguration, setActiveStep, renameConfiguration, cancelConfiguration } from '../../../features/configuration-management/ducks';
import { stepsConfig, configurationStatuses, possible_starter_selections, surveyTypes, surveyEventTypes, eventForceShowingSurvey, documentationKeys, IAC_SEND_MAIL_EVENT_NAMES } from '../../../constants';
import { getStepperLabels } from '../../../utils/linear-stepper';
import { openModal, closeModal } from '../../modals/ducks';
import { exportToMachineExpert, exportToPng, exportToXLS, exportToMyProduct, exportToMyProject, exportToAML, exportToMyList } from '../../export/ducks';
import { getDocumentation, getDatasheet, downloadDocuments } from '../../documentation-management/ducks';
import I10n from '../../../features/i10n';
import { showNotificationWithButton } from '../../notification/ducks';
import Configuration from '../../../models/Configuration';
import { shareConfiguration } from '../../configuration-management/ducks';
import EmailFormModal from '../../../components/email_form_modal';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import { setUserInformation, getUserInformation } from '../../user-information/ducks';
import { logDocumentationExportEvent, logSurveyOpenEvent, logSurveySubmitEvent, raiseIACAnalyticsEvent } from '../../../utils/analytics-logger';
import { getCartUrl } from '../../../utils/my-product';
import RulesDisplayer from '../../../components/rules_displayer';
import ApplicationFullHeader from '../../../components/application_full_header';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import { resetCBRSelectedItems } from '../../call-by-range/ducks';
import { getProductsAvailability } from '../../product-availability-information/ducks';
import Notification from '../../notification';
import NewBom from '../../../components/bill_of_materials_rework';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 2em);
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0;left: 0;right:0;bottom: 0;
    overflow: auto;
    background-color: white;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const ScreenContent = styled.div`
  position: relative;
  display: block;
  padding: 0px 24px 0px 16px;
  flex-direction: row;
`;

const Content = styled.div`
  flex: 1 1 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  @media(max-width: 800px) {
    display: block;
  }
`;

const HeaderSeparator = styled.div`
  border-top: 1px solid #e7e6e6;
  margin: 0px -16px;
`;

const ContentSeparator = styled.div`
  border-left: 1px solid #e7e6e6;
  margin-bottom: -5px;
`;

const BomWrapper = styled.div`
  padding-top: 10px;
  padding-right: 16px;
  @media (max-width: 800px) {
    padding-top: 0px;
    padding-right: 0px;
  }
`;

const SaveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-left: 40px;
  @media (max-width: 800px) {
    padding: 0px;
  }
`;

const DocumentationWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  padding: 5px 10px 10px 10px;
  @media (max-width: 800px) {
    padding: 5px 0px 0px 0px;
    margin-bottom: 0px;
  }
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const BOMContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileSection = styled.div`
  display: none;
  flex-direction: column;
  @media (max-width: 800px) {
    display: flex;
    margin-top: 5px;
  }
`;


class SaveScreen extends React.Component {

  constructor(props) {
    let showSurveyDisclaimer = false;
    try {
      if (props.configuration.showSurveyDisclaimer && appConfiguration.campaignId && localStorage.getItem(`iac-campaign-${appConfiguration.campaignId}`) == null) {
        showSurveyDisclaimer = true;
      }
    } catch(e) {}


    super(props);
    this.state = {
      emailForm: { isOpen: false, configuration: null },
      isDesktop: window.innerWidth > 800,
      workspaceOptionsOpened: false,
      showSurveyDisclaimer: showSurveyDisclaimer,
    }
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  get _isWrapperMode() {
    return window.self !== window.top;
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateIsDesktop);
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });
    this.props.getDatasheet(this.props.configuration);
    this.props.getDocumentation(this.props.configuration);
    this.props.getProductsAvailability(new Configuration(this.props.configuration).extractDistinctReferences());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsDesktop);
    this.props.closeModal();
  }

  saveConfiguration = (senderEmail, senderName, captchaResponse) => {
    this.props.saveConfiguration(this.props.configuration.id, this.props.configuration, senderEmail, senderName, captchaResponse, this._isWrapperMode).then(() => {
      this.props.showNotification(I10n.getAndReplace('screen.save_configuration.configuration_saved', this.props.configuration.name), 'success', null);
    });
    setUserInformation(senderEmail, senderName);
  }

  handleDownloadDocuments = (documents, documentName) => {
    return downloadDocuments(documents, this.props.configuration.name, documentName);
  }

  logDocumentationExport = (exportName, extension) => {
    logDocumentationExportEvent(this.props.configuration, exportName, extension);
  }

  renderRangeRules = (rangeInfo) => {
    return (
      <RulesDisplayer
        openModal={this.props.openModalFct}
        closeModal={this.props.closeModal}
        rangeName={rangeInfo.rangeName}
        starterType={this.props.configuration.starterType}
      >
      </RulesDisplayer>
    );
  }

  renderHeaderContent = (config) => {
    return (
      <HeaderContent>
        <ConfigurationHeader
          configuration={config}
          setConfigurationName={(name) => {
            this.props.renameConfiguration(config.id, name)
          }}
          isLoading={this.props.configurationSaver.isSaving}
          renderRangeRules={this.renderRangeRules}
        ></ConfigurationHeader>
      </HeaderContent>
    );
  }


  renderNavigationButtonSection = () => {
    const config = new Configuration(this.props.configuration);
    const buttons = <>
      <CancelWrapper>
        <Button
          onClick={event => {
            if (config.fullConfigurationHasDevicesToAccessorize()) {
              this.props.setActiveStep(stepsConfig.accessorize);
            } else {
              if (config.canUsePowerSupply()) {
                this.props.setActiveStep(stepsConfig.power_supply);
              } else {
                this.props.setActiveStep(stepsConfig.configuration_editor_screen);
              }
            }
          }}>
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {!appConfiguration.disableCallByRangeBackToStart && <Button
        primary
        onClick={event => {
          const isSaved = this.props.configuration.status === configurationStatuses.finished;
          this.confirmationBeforeCancellingConfiguration(isSaved, () => {
            this.props.setActiveStep(stepsConfig.start_screen);
          });
        }}>
        {I10n.get('app.action.go_to_start_page')}
      </Button>}
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          {buttons}
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  handleEmailFormOpen = (configuration) => {
    this.setState({ emailForm: { isOpen: true, configuration } });
  }

  handleEmailFormClose = () => {
    this.setState({ emailForm: { isOpen: false, configuration: null } });
  }

  handleEmailSubmit = (formData) => {
    const configurationId = this.state.emailForm.configuration.id;
    const configurationName = this.state.emailForm.configuration.name;
    this.handleEmailFormClose();
    setUserInformation(formData.senderEmail, formData.senderName);
    shareConfiguration(configurationId, formData.senderEmail, formData.senderName, formData.recipientEmail, formData.recipientName, formData.message, formData.captchaResponse, true)
      .then(() => {
        this.props.showNotification(
          I10n.getAndReplace('save_configuration.email_sent.notification', configurationName),
          'success',
          () => null
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSendMail = (configuration) => {
    const mailInformation = getUserInformation();
    this.props.openModalFct({
      modalType: 'send-email',
      modalProps: {
        senderName: mailInformation.senderName,
        senderEmail: mailInformation.senderEmail,
        onCancel: () => { this.props.closeModal(); },
        onSubmit: (formData) => {
          this.props.closeModal();
          const configurationId = configuration.id;
          const configurationName = configuration.name;
          setUserInformation(formData.senderEmail, formData.senderName);
          let sharePromise;
          if (formData.sendToMyself) {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, null, null, null, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          } else {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, formData.recipientEmail, formData.recipientName, formData.message, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          }
          sharePromise.then(() => {
            raiseIACAnalyticsEvent(IAC_SEND_MAIL_EVENT_NAMES.SEND_MAIL);
            this.props.showNotification(I10n.getAndReplace('save_configuration.email_sent.notification', configurationName), 'success', () => null);
          })
            .catch((error) => {
              console.log(error);
            });

        },
      }
    });
  }

  confirmationBeforeCancellingConfiguration = (isSaved, cancelCallback) => {
    if (isSaved) {
      cancelCallback();
    } else {
      this.props.openBackToStartModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => { cancelCallback(); this.props.closeModal(); this.props.cancelConfiguration(this.props.configuration.id); },
          title: I10n.get('screen.save_configuration.back_to_start.modal.title'),
          text: I10n.get('screen.save_configuration.back_to_start.modal.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    }
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      {
        action: () => {
          this.confirmationBeforeCancellingConfiguration(isSaved, () => {
            this.props.setActiveStep(stepsConfig.start_screen);
          });
        }, active: true, done: true, hidden: appConfiguration.disableCallByRangeBackToStart
      },
      {
        action: () => {
          this.props.resetCallByRangeSelectedItems();
          this.props.setActiveStep(stepsConfig.head_device_selector_screen);
        }, active: true, done: true
      },
      { action: () => { this.props.setActiveStep(stepsConfig.configuration_editor_screen); }, active: true, done: true },
      { action: () => { this.props.setActiveStep(stepsConfig.power_supply); }, active: config.canUsePowerSupply(), hidden: config.starterType === possible_starter_selections.PAC, done: true, skipped: config.canUsePowerSupply() && !config.hasPowerSupplies() },
      { action: () => { this.props.setActiveStep(stepsConfig.accessorize); }, active: config.fullConfigurationHasDevicesToAccessorize(), done: true, skipped: !config.hasDeviceAccessorized() && !config.hasSoftwareLicenseSelection() },
      { action: () => { }, active: true, done: true },
    ];
  }

  performAddToCart = (configuration) => {
      if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
        this.props.exportToMyProject(configuration);
      } else {
        const x = this.props.exportToMyProduct(configuration);
        x.then(() => {
          if (window.top === window.self) {
            this.props.showNotification(
              I10n.get('add_to_my_product.notification'),
              'success',
              () => (
                <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                  {I10n.get('add_to_my_product.notification.button')}
                </Button>
              )
            );
          }
        }).catch(() => {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification.error'),
            'error',
            null
          );
        });
      }
    }

  addToMyProduct = (config) => {
    if (config.containsPrecommercializedProducts()) {
      this.props.openModalFct({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            this.performAddToCart(config);
            this.props.closeModal();
          },
          title: I10n.get('important_information'),
          text: I10n.get((appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable || appConfiguration.launchFromWorkspace) ? 'precommercialized_products_warning.body.project_builder' : 'precommercialized_products_warning.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      this.performAddToCart(config);
    }
  }

  addToMyList = (config) => {
    if (config.containsPrecommercializedProducts()) {
      this.props.openModalFct({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            this.props.exportToMyList(config);
            this.props.closeModal();
          },
          title: I10n.get('important_information'),
          text: 'precommercialized_products_warning.body',
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      this.props.exportToMyList(config);
    }
  }

  renderBOM = (config) => {
    return <NewBom
      id={this.props.id}
      configuration={config}
      references={config.extractReferencesForBOM().extractSortedReferences()}
      islands={config.extractReferencesByIsland(true)}
      configurationName={config.name}
      preferredProductReference={appConfiguration.preferredProductReference}
      isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
      unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
      favoritesDisabled={this.props.export.my_product.isLoading || this.props.configurationSaver.isSaving}
      allowBOMFavorites={true}
      onAddToFavorites={() => {
        const x = this.props.exportToMyProduct(config);
        x.then(() => {
          if (window.top === window.self) {
            this.props.showNotification(
              I10n.get('add_to_my_product.notification'),
              'success',
              () => (
                <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                  {I10n.get('add_to_my_product.notification.button')}
                </Button>
              )
            );          }
        }).catch(() => {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification.error'),
            'error',
            () => (
              <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                {I10n.get('add_to_my_product.notification.button')}
              </Button>
            )
          );


        })
      }}
      availabilityStatus={this.props.productsAvailability.availabilityStatus}
      showAvailabilityStatus={true}
    >
    </NewBom>;
  }

  renderSavedSection = (config) => {
    const mailInformation = getUserInformation();
    return <SaveWrapper>
      {config.status === configurationStatuses.finished ?
        <SavedConfigurationSection
          configuration={config}
          exportToMachineExpert={this.props.exportToMachineExpert}
          exportToPng={this.props.exportToPng}
          exportToXls={this.props.exportToXls}
          exportToAml={this.props.exportToAml}
          addToMyProduct={this.addToMyProduct}
          addToMyList={this.addToMyList}
          addToMyProductLabel={appConfiguration.addToMyProductLabel}
          addToListLabel={appConfiguration.addToListLabel}
          export={this.props.export}
          showNotification={this.props.showNotification}
          handleEmailFormOpen={this.onSendMail}
          openModal={this.props.openModalFct}
          closeModal={this.props.closeModal}
          isWrapperMode={this._isWrapperMode}
          allowSavedModifications={this.props.configuration.allowSavedModifications}
          workspaceOptionsOpened={this.state.workspaceOptionsOpened}
          toggleWorkspaceOptions={() => { this.setState({ workspaceOptionsOpened: !this.state.workspaceOptionsOpened }); }}
          seamlessSession={appConfiguration.seamlessSession}
          launchFromWorkspace={appConfiguration.launchFromWorkspace}
          isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
          unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        >
        </SavedConfigurationSection>
        :
        <SaveConfiguration
          senderEmail={mailInformation.senderEmail}
          senderName={mailInformation.senderName}
          onSave={(senderEmail, senderName, captchaResponse) => {
            this.saveConfiguration(senderEmail, senderName, captchaResponse);
          }}
          isSaving={this.props.configurationSaver.isSaving}
          isWrapperMode={this._isWrapperMode}
        >
        </SaveConfiguration>
      }
      {((!appConfiguration.launchFromWorkspace && !appConfiguration.unifiedCheckoutAvailable) || !this._isWrapperMode || this.state.workspaceOptionsOpened) && <DocumentationWrapper>
        <DocumentationSection
          documentsLoading={this.props.documentationReducer.isLoading}
          hideDatasheets={false}
          datasheetsLoading={this.props.datasheetReducer.isLoading}
          documentTypes={this.props.documentationReducer.documentTypes}
          datasheetTypes={this.props.datasheetReducer.documentTypes}
          downloadDocuments={this.handleDownloadDocuments}
          logExport={this.logDocumentationExport}
          documentationKeys={documentationKeys}
        >
        </DocumentationSection>
      </DocumentationWrapper>}
    </SaveWrapper>;

  }

  renderScreenContent = (config) => {
    const mailInformation = getUserInformation();
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <Notification>
          </Notification>
          {this.renderHeaderContent(config)}
          <HeaderSeparator></HeaderSeparator>
          <Content>
            <BOMContainer>
              <BomWrapper>
                {this.renderBOM(config)}
              </BomWrapper>
            </BOMContainer>
            <ContentSeparator></ContentSeparator>
            {this.renderSavedSection(config)}
            <MobileSection>
              <BomWrapper>
                {this.renderBOM(config)}
              </BomWrapper>
            </MobileSection>
            {this.state.emailForm.isOpen && (
              <EmailFormModal
                senderEmail={mailInformation.senderEmail}
                senderName={mailInformation.senderName}
                onClose={this.handleEmailFormClose}
                onSubmit={this.handleEmailSubmit}
                i10n={I10n}>
              </EmailFormModal>
            )}
          </Content>
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading && <Survey
            appTitle={I10n.get('app.title.' + this.props.configuration.starterType)}
            surveyData={this.props.survey?.surveyData}
            getLabel={(key) => I10n.get(key)}
            onOpen={() => {
              logSurveyOpenEvent(surveyEventTypes.generic_open, config.id, stepsConfig.save_screen);
            }}
            onSubmit={(surveyAnswers) => {
              logSurveySubmitEvent(surveyEventTypes.generic_sent, config.id, stepsConfig.save_screen, surveyAnswers);
            }}
            fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
            color={appConfiguration.globalStyles.secondaryColor}
            showDisclaimer={this.state.showSurveyDisclaimer}
            campaignId={appConfiguration.campaignId}
          ></Survey>}
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.title.' + this.props.configuration.starterType)}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              const isSaved = this.props.configuration.status === configurationStatuses.finished;
              this.confirmationBeforeCancellingConfiguration(isSaved, () => {
                this.props.setActiveStep(stepsConfig.start_screen);
              });
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getStepperLabels(config.starterType)}
          activeStep={stepsConfig.save_screen}
          stepperActions={this.getStepperActions(isSaved)}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={false}
          showPrecommWarning={this.props.configuration.showPrecommercializedProducts || config.containsPrecommercializedProducts()}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config))}
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openBackToStartModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    openModalFct: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    exportToMachineExpert: (configurationID) => dispatch(exportToMachineExpert(configurationID)),
    exportToPng: (configuration) => dispatch(exportToPng(configuration)),
    exportToXls: (configuration) => dispatch(exportToXLS(configuration, stepsConfig.save_screen)),
    exportToAml: (configuration) => dispatch(exportToAML(configuration)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    exportToMyList: (configuration) => dispatch(exportToMyList(configuration)),
    renameConfiguration: (configId, name) => dispatch(renameConfiguration(configId, name)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    saveConfiguration: (configId, configuration, senderEmail, senderName, captchaResponse, isWrapperMode) => dispatch(saveConfiguration(configId, configuration, senderEmail, senderName, captchaResponse, isWrapperMode)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    getDocumentation: (configuration) => dispatch(getDocumentation(configuration)),
    getDatasheet: (configuration) => dispatch(getDatasheet(configuration)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    getSurvey: () => dispatch(getSurvey(surveyTypes.generic)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({ survey: false })),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    getProductsAvailability: (refIds) => dispatch(getProductsAvailability(refIds))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveScreen);
